import React from 'react';
import styles from './Contact.module.css';

const Contact = () => {
  return (
    <section className={styles.contact}>
      <h2>GET IN TOUCH</h2>
      <p className="contact-info">
          <strong>B.E.T.A Edge Inc.</strong> <br/>
          <br/>
          <strong>Global & Innovation Center:</strong><br/>
         
          Kolkata, India. <br />
          <br/>
          <strong>Our Nexus Points:</strong>
          <br/>

          Buona Vista, Singapore. <br/>
          New Taipei City, Taiwan.<br/>
          Kowloon Tong, Hong Kong. <br/>
          <br/>
          <strong>Write to us:</strong> <br/>
          connect@beta-edge.com <br/>
          <br/>
          <strong>Dial us:</strong> <br/>
          (+91) 9804 619 202. <br/>
          (+65) 9167 3307.
        </p>



      {/* <form>
        <input type="text" placeholder="Your Name" required />
        <input type="email" placeholder="Email Address" required />
        <textarea placeholder="Your Message" rows="5" required></textarea>
        <button type="submit">Send Message</button>
      </form> */}
    </section>
  );
};

export default Contact;
